import { createEditorContentUnifiedQueryVariables } from '@confluence/editor-content-unified-query/entry-points/createEditorContentUnifiedQueryVariables.ts';
import { expValEquals, isExperimentEnabled } from '@confluence/feature-experiments';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useTitleContentPropertiesForEditorQuery, {
	type useTitleContentPropertiesForEditorQuery$data,
	type useTitleContentPropertiesForEditorQuery$variables,
} from './__generated__/useTitleContentPropertiesForEditorQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export const preloadEditorPageTitleContentProperties = async ({
	contentId,
	draftShareId,
	useCache,
}: {
	contentId?: string | null;
	draftShareId: string;
	useCache: boolean;
}): Promise<{
	data: useTitleContentPropertiesForEditorQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> => {
	const variables = {
		contentId,
		status: ['current', 'draft', 'archived'],
		draftShareId,
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	};
	return query<
		useTitleContentPropertiesForEditorQuery$data,
		useTitleContentPropertiesForEditorQuery$variables
	>({
		query: useTitleContentPropertiesForEditorQuery,
		variables:
			contentId && expValEquals('confluence_editor_content_unified_query', 'isEnabled', true)
				? createEditorContentUnifiedQueryVariables({ contentId })
				: variables,
		fetchPolicy: expValEquals('confluence_editor_content_unified_query', 'isEnabled', true)
			? useCache
				? 'cache-first'
				: 'network-only'
			: undefined,
		// Keep Relay records through the title hook's lifetime, including the gap before it mounts.
		relayQueryPreloadRetention: isExperimentEnabled('platform_editor_reduce_forced_layout')
			? 'hook-unmount'
			: undefined,
	});
};
